



































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import SetDispositionMenu from "@/components/Call/SetDispositionMenu.vue";
import moment from "moment";
import logger from "@/configs/logger";
import { objectify } from "@/helpers";
import { Datetime } from "vue-datetime";

import "vue-datetime/dist/vue-datetime.css";

@Component({ components: { SetDispositionMenu, Datetime } })
export default class IncomingCallDialog extends Vue {
  @Action("getWrapupTasks") getWrapupTasks!: Function;
  @Action("setDisposition") setDisposition!: Function;
  @Action("getDispositions") getDispositions!: Function;
  @Action("addCallback") addCallback!: Function;

  wrapupTasks: any[] = [];
  dialog = false;
  dispositionSelectError = false;
  dispositionNoteInputError = false;
  dispositionNoteAddLoading = false;
  dispositionNote = "";
  selectedDisposition = "";

  dispositions = [];

  datetime = new Date().toISOString();
  minDate = new Date().toISOString();

  async mounted() {
    this.dispositions = await this.getDispositions(this.task);
  }

  get dispositionValues() {
    return this.dispositions.map((val: any) => val.name);
  }

  get task() {
    return this.wrapupTasks[0] || {};
  }

  get createdTime() {
    const { created_ts } = this.task;
    if (!created_ts) return "";
    return moment.unix(created_ts.seconds).format("MMM Do YYYY, h:mm:ss a");
  }

  // not prod ready
  // get requiresCallback(): any {
  //   const dispositionObject: any = this.dispositions.find(
  //     (dispo: any) => dispo.name === this.selectedDisposition
  //   );

  //   return objectify(dispositionObject).callback;
  // }

  async getWrapUps() {
    this.wrapupTasks = await this.getWrapupTasks();
    if (this.wrapupTasks.length) {
      this.dialog = true;
    }
  }

  onSetDisposition(disposition: string) {
    this.selectedDisposition = disposition;
  }

  requiresDispositionNote(disposition: string, ignoreDisposition: boolean) {
    const task = objectify(this.task);
    const taskCreationSource = task.task_creation_source;
    const leadSource = task.lead_source;

    if (ignoreDisposition) {
      return false;
    }

    if (leadSource == "platinum" || leadSource == "raw_dialer_callback") {
      return false;
    }

    if (
      taskCreationSource == "outbound_dial" ||
      taskCreationSource == "agent_callback"
    ) {
      return false;
    }

    if (taskCreationSource === "vendor_transfer") {
      return true;
    }

    return true;
  }

  async onQuickDisposition(disposition: string) {
    try {
      this.selectedDisposition = disposition;
      await this.submitDisposition(true);
    } catch (err) {
      logger("log", "quick disposition error:", err);
    }
  }

  async submitDisposition(ignoreDisposition: boolean): Promise<void> {
    if (this.selectedDisposition === "") {
      this.dispositionSelectError = true;
    } else if (
      this.requiresDispositionNote(
        this.selectedDisposition,
        ignoreDisposition
      ) &&
      this.dispositionNote === ""
    ) {
      this.dispositionNoteInputError = true;
    } else {
      this.dispositionNoteAddLoading = true;
      await this.setDisposition({
        disposition: this.selectedDisposition,
        disposition_note: this.dispositionNote,
        taskId: this.task.id
      });

      if (this.selectedDisposition === "Call Back") {
        logger("info", "setting callback", this.selectedDisposition);
        await this.addCallback({
          time: this.datetime,
          leadName: this.task.lead_name,
          leadKey: this.task.lead_key,
          userKey: this.task.reservation_user_key
        });
      }

      this.dispositionNoteAddLoading = false;
      this.dialog = false;
    }
  }

  created() {
    this.getWrapUps();
  }
}
